import { ErrorBoundary } from 'react-error-boundary';
import { Heading } from 'yoso';
import { EvolveErrorFallback } from '~/components/Evolve/Error/EvolveErrorFallback';
import { EvolutionStatusList } from '~/components/Evolve/Status/List/EvolutionStatusList';
import { T } from '~/components/I18n';
import styles from './EvolutionStatus.module.scss';

export const EvolutionStatus = () => (
  <div className={styles.root}>
    <div className={styles.header}>
      <Heading level={3} className={styles.title}>
        <T name="citizen_evolve_ready" />
      </Heading>
    </div>
    <div className={styles.body}>
      <ErrorBoundary FallbackComponent={EvolveErrorFallback}>
        <EvolutionStatusList />
      </ErrorBoundary>
    </div>
  </div>
);
